var map = {
	"./datum-old.jpg": 8124,
	"./datum.jpg": 9156,
	"./flamen-old.jpg": 480,
	"./flamen.jpg": 2015,
	"./freta.jpg": 8574,
	"./gaiac.jpg": 4730,
	"./hakia_city.jpg": 8037,
	"./hiems_duchy-old.jpg": 9975,
	"./hiems_duchy.jpg": 2999,
	"./img_bask_map.png": 2895,
	"./img_datum.png": 1673,
	"./img_gaiac.png": 3778,
	"./img_last.png": 3375,
	"./img_narrabilis.png": 4920,
	"./img_rasul.png": 6857,
	"./img_title_datum.png": 9995,
	"./img_title_datum.svg": 1683,
	"./img_title_gaiac.png": 706,
	"./img_title_gaiac.svg": 932,
	"./img_title_last.png": 6665,
	"./img_title_last.svg": 594,
	"./img_title_narrabilis.png": 5548,
	"./img_title_narrabilis.svg": 5390,
	"./img_title_rasul.png": 9567,
	"./img_title_rasul.svg": 2228,
	"./intro.png": 1162,
	"./jonstina_dukedom.jpg": 7839,
	"./koivikko.jpg": 4719,
	"./last-old.jpg": 7585,
	"./last.jpg": 7681,
	"./narrabillis.jpg": 7938,
	"./nissrel.jpg": 6618,
	"./rasul-old.jpg": 8497,
	"./rasul.jpg": 1422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7361;